import request from '@/utils/request'

let DserviceApi = {

  /*地图服务列表*/
  list(data) {
    return request._post('/shop/plus.dservice.Index/index', data);
},
/*添加地图服务*/
add(data) {
    return request._post('/shop/plus.dservice.Index/add', data);
},
/*修改地图服务*/
edit(data) {
    return request._post('/shop/plus.dservice.Index/edit', data);
},
/*删除地图服务*/
del(data) {
    return request._post('/shop/plus.dservice.Index/del', data);
},
getPlatformm(){
    return request._post('/shop/plus.platformm.Index/index');
},
/*地图服务详情*/
detail(data) {
  return request._post('/shop/plus.dservice.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.dservice.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.dservice.Setting/getSetting', data, errorback);
    },
}
export default DserviceApi;



// WEBPACK FOOTER //
// ./src/api/dservice.js